<ng-container [formGroup]="parentGroup">
  <div class="mobi-ui-card-minor is-centered-y is-size-lg mobi-ui-flow-x-xs">
    <mobi-ui-text-block-major icon="tie" [title]="title">
      <p class="mobi-ui-margin-t-sm">
        {{ text }}
      </p>
      <div class="mobi-ui-margin-t-sm flex items-start">
        <mobi-ui-switch-major
          [attr.aria-label]="cost"
          [value]="contribute()"
          [disabled]="contributeRequired"
          (valueChange)="onContributeChange($event)"
          class="!my-0"
        />
        <div class="mobi-ui-margin-l-xs">
          <span class="block mobi-ui-font-bold">
            {{ cost }}
          </span>
          @if (contribute()) {
            <span class="block">
              {{
                'compliance_guidelines_cost_text'
                  | texts
                    : {
                        context,
                        default:
                          'Vielen Dank. Die zuständige Generalagentur wird sich mit Ihnen in Verbindung setzen.',
                      }
              }}
            </span>
          }
        </div>
      </div>
      <mobi-ui-form-field-major class="block mobi-ui-margin-t-sm">
        <mobi-ui-checkbox-group-major
          [aria-label]="accept"
          [formControl]="acceptedControl"
          [id]="fieldId"
          [class.has-required-error]="showRequiredError"
        >
          <mobi-ui-checkbox-major [name]="fieldId" [multiline]="true">
            {{ accept }}
          </mobi-ui-checkbox-major>
        </mobi-ui-checkbox-group-major>
        @if (showRequiredError) {
          <mobi-ui-form-message-major class="mobi-ui-margin-t-xs" level="error">
            {{ requiredError }}
          </mobi-ui-form-message-major>
        }
      </mobi-ui-form-field-major>
    </mobi-ui-text-block-major>
  </div>
</ng-container>
